const cookieHref = '/about/privacy-policy/#cookie';
const sravniITinfoHref = 'https://f.sravni.ru/cms/file/filepath/information_about_it_activities_sravni.pdf';
const sravniConsolidatedReport2025 = 'https://s91588.cdn.ngenix.net/footer/Сводная_ведомость_результатов_СОУТ_+_Перечень_мероприятий_по_улучшению_условий_труда_Сравни_2025.PDF';
const sravniConsolidatedReport2024 = 'https://s91588.cdn.ngenix.net/footer/Сводная_ведомость_СОУТ+План_мероприятий__по_улучшению_условий_труда_Сравни.ру_2024г.PDF';

export { cookieHref, sravniConsolidatedReport2024, sravniConsolidatedReport2025, sravniITinfoHref };
//# sourceMappingURL=links.js.map
